import script from "./BenefitsCalculatorResultsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BenefitsCalculatorResultsPage.vue?vue&type=script&setup=true&lang=ts"

import "./BenefitsCalculatorResultsPage.vue?vue&type=style&index=0&id=7ef00cf3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ef00cf3"]])

export default __exports__